import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  userName: "",
  userLastName: "",
  sidebarMenuRole: 0,
  role: 2,
  user_id: 0,
  profilePicture: "",
  myAvatar: "",
  callStatus: false,
  backDropLoaderStatus: false,
  updateServiceRequestStatus: false,
  backDropLoaderWithoutUpdate: false,
  inVideoCallStatus: false,
  loaderTime: 10000,
  backDropLoaderRejectedCase: false,
  notificationCount: 0,
  notificationTypeRedux: 1,
  drawingArea: false,
  emailRedux: "",
  phoneNumberRedux: 0,
  phoneCodeRedux: 0,
  paymentMethodID: "",
  customerID: "",
  connectedAccountId: "",
  subscriptionId: "",
  subscriptionPaidStatus: "",
  isUpcomingPlanFlag: false,
  upcomingSubscriptionStatus: 0,
  upcomingPlanProductId: '',
  upcomingPlanStartDate: 0,
  freeTrialProductId: "",
  freeTrialStatus: "",
  freeTrialPrevSubscriptionId: "",
  isFreeTrialSubscription: false,
  activeSubscriptionEndTime: "",
  paidProductId: "",
  permissionArr: [],
  impersonateFlag: false,
  impersonateUserId: "",
  impersonateRoleId: 0,
  impersonateAccessToken: "",
  impersonateRefreshToken: "",
  rolesUserCanAssign: [],
  roleDisplayName: "",
  currentPage: "",
  isVerified: 0,
  avgRatingFloat: 0,
  referralLink: '',
  companyId: '',
  isAvailable: 0,
  totalCallTimeRedux: 0,
  proExpertiseFlag: false,
  proDocumentsFlag: false,
  proOnboardingFlag: true,
  serviceRequestOptions: [],
  serviceRequestFlagPro: 0,
  inProgressServiceCount: 0,
  roleArr: [],
  userProfileTab: 1,
  isSubscribedUser: 0,
  billingCycleAnchorDate: 0,
  isActiveCall: false,
  subscriptionLicenseQuantity: 0,
  subscriptionProductAmont: 0,
  subscriptionType: '',
  remainingVideoInvitationCount: 0,
  isSignUpFlag: false,
  totalMonthlyFreeVideoLinkCount: 0,
  accountDetailsModalTriggerRedux: false,
  expertiseTriggerRedux: false,
  documentsModalTriggerRedux: false,
  feedbackModalRedux: false,
  totalCreditsInCents: 0,
  recordingPermission:true,
  doingBusinessAsName:'',
  downloadAppBar: false,
  isCheckInCall: false,
  proOptionFlag: 2,
  proOptionList: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    resetState: () => initialState,
    setRoleRedux: (state, action) => {
      const userD = action.payload;

      state.role = userD;
    },
    setUserDetails: (state, action) => {
      const userData = action.payload;

      localStorage.setItem("user_role", userData.role_id_int);
      state.userName = userData.first_name_chr;
      state.userLastName = userData.last_name_chr;
      state.doingBusinessAsName = userData.alias_name_chr;
      state.role = userData.role_id_int;
      state.sidebarMenuRole = userData.role_id_int;
      state.user_id = userData.user_id_ids;
      state.myAvatar = userData.avatar_url;
      state.profilePicture = userData.preferred_profile_picture_url;
      state.emailRedux = userData.email_chr;
      state.phoneNumberRedux = userData.phone_number_int;
      state.phoneCodeRedux = userData.phone_code_id_lng;
      state.paymentMethodID = userData?.payment_method_id_chr
        ? userData?.payment_method_id_chr
        : "";
      state.customerID = userData?.customer_id_chr
        ? userData?.customer_id_chr
        : "";
      state.connectedAccountId = userData?.connected_account_id_chr
        ? userData?.connected_account_id_chr
        : "";
      state.subscriptionId =
        // (!userData?.current_plan_details?.is_free_flag &&
        (userData?.current_plan_details?.subscription_status_chr === "active" || userData?.current_plan_details?.subscription_status_chr === "canceled")
          // ) 
          ?
          userData?.current_plan_details?.subscription_id_chr
          : "";
      state.subscriptionPaidStatus =
        (!userData?.current_plan_details?.is_free_flag) ?
          userData?.current_plan_details?.subscription_status_chr
          : "";
      state.isUpcomingPlanFlag = userData?.current_plan_details?.is_upcoming_plan_flag;
      state.upcomingPlanProductId = userData?.current_plan_details?.is_upcoming_plan_flag ? userData?.all_plans[1]?.product_id_chr : '';
      state.upcomingPlanStartDate = userData?.current_plan_details?.is_upcoming_plan_flag ? userData?.all_plans[1]?.start_date_dtm_unix : 0;
      state.upcomingSubscriptionStatus =
        (userData?.current_plan_details?.is_upcoming_plan_flag) ?
          userData?.current_plan_details?.is_upcoming_canceled_ysn
          : 0;
      state.freeTrialProductId = (userData?.current_plan_details?.is_free_flag) ?
        userData?.current_plan_details?.product_id_chr : "";
      state.paidProductId = (!userData?.current_plan_details?.is_free_flag && userData?.current_plan_details?.product_id_chr !== "prod_free_trial_01") ?
        userData?.current_plan_details?.product_id_chr : "";
      state.freeTrialStatus = (userData?.current_plan_details?.is_free_flag) ?
        userData?.current_plan_details?.subscription_status_chr : "";
      state.freeTrialPrevSubscriptionId = userData?.free_trial_details?.product_id_chr !== "prod_free_trial_01" && userData?.free_trial_details?.previous_subscription_id_chr;
      state.activeSubscriptionEndTime = (userData?.current_plan_details?.product_id_chr !== "prod_free_trial_01") ? userData?.current_plan_details?.end_date_dtm_unix : 0;
      state.isFreeTrialSubscription = (userData?.current_plan_details?.product_id_chr !== "prod_free_trial_01") && userData?.current_plan_details?.is_free_flag;
      state.billingCycleAnchorDate = userData?.current_plan_details?.billing_cycle_anchor_date ? userData?.current_plan_details?.billing_cycle_anchor_date : 0;
      state.subscriptionLicenseQuantity = userData?.current_plan_details?.quantity_int ? userData?.current_plan_details?.quantity_int : 0;
      state.subscriptionProductAmont = userData?.current_plan_details?.product_amount_int ? userData?.current_plan_details?.product_amount_int : 0;
      state.subscriptionType = userData?.current_plan_details?.subscription_type_chr;
      state.permissionArr = [];
      state.permissionArr.push(userData?.permissions || userData?.user_permissions);
      state.rolesUserCanAssign = userData?.assign_role_list
      state.roleDisplayName = userData?.role_display_name_chr;
      state.isVerified = userData?.is_verified_ysn;
      state.avgRatingFloat = userData?.avg_rating_float;
      state.referralLink = userData?.referral_link;
      state.companyId = userData?.company_id_lng;
      state.isAvailable = userData?.is_available_ysn;
      state.proExpertiseFlag = userData?.pro_expertise_flag;
      state.proDocumentsFlag = userData?.pro_documents_flag;
      state.serviceRequestOptions = userData?.service_request_options;
      state.serviceRequestFlagPro = userData?.service_request_flag;
      state.roleArr = userData?.roles;
      state.isSubscribedUser = userData?.is_subscribed_user_ysn;
      state.remainingVideoInvitationCount = userData?.remaining_video_invitation_count;
      state.inProgressServiceCount = userData?.in_progress_services_count;
      state.totalCreditsInCents = userData?.total_credits_in_cents_float;
      state.proOptionFlag = userData?.pro_option;
      state.proOptionList = userData?.pro_options || [];
    },
    callTrue: (state) => {
      state.callStatus = true;
    },

    callFalse: (state) => {
      state.callStatus = false;
    },
    notificationReduxState: (state, action) => {
      const userData = action.payload;
      state.notificationTypeRedux = userData.data.notification_type != "12" ? userData.data.notification_type : state.notificationTypeRedux;
    },
    backLoaderTrue: (state) => {
      state.backDropLoaderStatus = true;
    },
    backLoaderFalse: (state) => {
      state.backDropLoaderStatus = false;
    },
    updateServiceReqModalTrue: (state) => {
      state.updateServiceRequestStatus = true;
    },
    updateServiceReqModalFalse: (state) => {
      state.updateServiceRequestStatus = false;
    },
    updateBackDropLoaderWithoutStateTrue: (state) => {
      state.backDropLoaderWithoutUpdate = true;
    },
    updateBackDropLoaderWithoutStateFalse: (state) => {
      state.backDropLoaderWithoutUpdate = false;
    },
    setLoaderTime: (state, action) => {
      state.loaderTime = action.payload.waiting_time_in_sec_int;
    },
    backDropLoaderRejectedCaseRedux: (state, action) => {
      state.backDropLoaderRejectedCase = action.payload;
    },
    setNotificationCount: (state, action) => {
      const userData = action.payload;
      state.notificationCount = userData;
    },
    drawActive: (state) => {
      state.drawingArea = true;
    },
    drawDisable: (state) => {
      state.drawingArea = false;
    },
    setImpersonateFlag: (state, action) => {
      state.impersonateFlag = action.payload;
    },
    setImpersonateUserId: (state, action) => {
      state.impersonateUserId = action.payload;
    },
    setImpersonateRefreshToken: (state, action) => {
      state.impersonateRefreshToken = action.payload;
    },
    setImpersonateAccessToken: (state, action) => {
      state.impersonateAccessToken = action.payload;
    },
    setImpersonateRoleId: (state, action) => {
      state.impersonateRoleId = action.payload;
    }

    ,
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },

    setTotalCallTimeRedux: (state, action) => {
      state.totalCallTimeRedux = action.payload * 1000
    },
    setProOnboardingFlag: (state, action) => {
      state.proOnboardingFlag = false
    },
    setInprogressServiceCount: (state, action) => {
      state.inProgressServiceCount = action.payload
    },

    setUserProfileTab: (state, action) => {
      let val = action.payload
      state.userProfileTab = val;
    },
    setActiveCall: (state) => {
      state.isActiveCall = true;
    },
    setInactiveCall: (state) => {
      state.isActiveCall = false;
    },
    setIsSignUpFlagTrue: (state) => {
      state.isSignUpFlag = true;
    },
    setIsSignUpFlagFalse: (state) => {
      state.isSignUpFlag = false;
    },
    setTotalMonthlyFreeVideoLink: (state, action) => {
      state.totalMonthlyFreeVideoLinkCount = action?.payload?.total_monthly_free_video_link_count;
    },
    setAccountDetailsModalTriggerRedux: (state, action) => {
      state.accountDetailsModalTriggerRedux = action.payload;
    },
    setExpertiseTriggerRedux: (state, action) => {
      state.expertiseTriggerRedux = action.payload;
    },
    setDocumentsModalTriggerRedux: (state, action) => {
      state.documentsModalTriggerRedux = action.payload;
    },
    setFeedbackModalRedux: (state, action) => {
      state.feedbackModalRedux = action.payload;
    },
    setRecordingPermission:(state, action) => {
      console.log(action,"My Values ")
      state.recordingPermission = action.payload
    },
    setDownloadAppBar : (state, action) => {
      state.downloadAppBar = action.payload
    },
    setIsCheckInCall : (state, action) => {
      state.isCheckInCall = action.payload
    }
  },
});

export const {
  setRoleRedux,
  localDisconnectCall,
  drawDisable,
  drawActive,
  setNotificationCount,
  setUserDetails,
  backLoaderTrue,
  backLoaderFalse,
  updateServiceReqModalTrue,
  updateServiceReqModalFalse,
  updateBackDropLoaderWithoutStateTrue,
  updateBackDropLoaderWithoutStateFalse,
  setLoaderTime,
  backDropLoaderRejectedCaseRedux,
  setWaitingTimeFn,
  callTrue,
  callFalse,
  notificationReduxState,
  setImpersonateFlag,
  setImpersonateUserId,
  resetState,
  setImpersonateAccessToken,
  setImpersonateRefreshToken,
  setImpersonateRoleId,
  setCurrentPage, myAvatar,
  setTotalCallTimeRedux,
  setProOnboardingFlag,
  setInprogressServiceCount,
  setUserProfileTab,
  setActiveCall,
  setInactiveCall,
  setIsSignUpFlagTrue,
  setIsSignUpFlagFalse,
  setTotalMonthlyFreeVideoLink,
  setAccountDetailsModalTriggerRedux,
  setExpertiseTriggerRedux,
  setDocumentsModalTriggerRedux,
  setFeedbackModalRedux,
  setRecordingPermission,
  setDownloadAppBar,
  setIsCheckInCall,
} = userSlice.actions;

export default userSlice.reducer;
